import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { store } from 'react-notifications-component';
import NumberFormat from 'react-number-format';
import { useGlobalContext } from '../../../context/GlobalContext';
import arrow from '../../../../assets/images/icons/arrow.svg';
import gift from '../../../../assets/images/icons/gift.svg';
import fist from '../../../../assets/images/icons/fist.svg';
import promo from '../../../../assets/images/icons/promo.svg';
import styles from './EditOffer.module.scss';
import { getAssetPath, toBase64 } from '../../../../utils/utils';
import { ERROR_OFFERS, MESSAGE_OFFERS } from '../../../../actions/types';
import { availabilityOptions, offersStatusOptions } from '../../../../constants/constants';
import { deleteOfferAction, getOfferAction, postProductAction, putProductAction } from '../../../../actions/offersActions';
import Input from '../../../Partials/form_fields/Input';
import InputImage from '../../../Partials/form_fields/InputImage/InputImage';
import Textarea from '../../../Partials/form_fields/Textarea';
import { getProviderAction, getProvidersListAction } from '../../../../actions/providersActions';
import StyledSelect from '../../../Partials/form_fields/StyledSelect/StyledSelect';
import { API_URL } from '../../../../actions';

const required = "Ce champ est requis";

function parseLocaleNumber(input) {
  if (input === '' || input === null || input === undefined) return null;
  if (typeof input === 'number') return Number.isFinite(input) ? input : null;
  const normalized = String(input)
    .trim()
    .replace(/\s+/g, '')
    .replace(',', '.');
  if (normalized === '') return null;
  const n = Number.parseFloat(normalized);
  return Number.isFinite(n) ? n : null;
}

function roundTo2(n) {
  if (n === null || n === undefined) return null;
  const num = typeof n === 'number' ? n : Number(n);
  if (!Number.isFinite(num)) return null;
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

// Correspondance "Famille de produit" -> numéro de dossier (fileNumber)
// Les labels doivent matcher ceux présents dans `context.providers.provider.company.products`
const fileNumberByProductLabel = {
  'IMAGE': '821028',
  'AUDIO': '821029',
  'INFORMATIQUE': '821023',
  'PHOTO': '821023',
  'TELEPHONIE': '821026',
  'GPS': '821023',
  'ACCESSOIRES / OBJETS CO': '821027',
  'PEM': '821030',
  'GEM': '821031',
  'MOBILITE URBAINE': '821027',
};

function resolveFileNumber(productLabel) {
  if (!productLabel) return null;
  const normalized = String(productLabel)
    .trim()
    .toUpperCase()
    .replace(/\s+/g, ' ');

  return fileNumberByProductLabel[normalized] ?? fileNumberByProductLabel[productLabel] ?? null;
}

export default function EditOffer({ setActivePage  }) {
  const [ context , dispatch ] = useGlobalContext();
  const { id } = useParams();
  const history = useHistory();

  const productsOptions = context.providers?.provider?.company?.products?.map((p) => ({ value: p, label: p }));
  const { offer, message, error }  = context.offers;
  const providersOptions = context.providers?.providersList?.map((p) => ({ value: p._id, label: p.name})) || [];

  const containerRef = useRef();
  const [ adventage, setAdventage] = useState({ type: null , value: null });
  const [form, setForm ] = useState({
    status: 'pending',
  });
  const price = parseLocaleNumber(form.price);
  const pricePA = parseLocaleNumber(form.pricePA);
  const discountValue = price && pricePA ? 100 - (price * 100) / pricePA : 0;
  const discount = parseFloat(discountValue).toFixed(2);
  const [errors, setErrors] = useState({})
  const isDataUrl = (v) => typeof v === 'string' && v.startsWith('data:') && v.includes(';base64,');

  const defaultImageValue = form?.image?.path
    ? `${API_URL}/files/${form.image.path.replace('upload/', '')}`
    : (isDataUrl(form?.image) ? form.image : null);

  const defaultFileValue = form?.file?.path
    ? `${API_URL}/files/${form.file.path.replace('upload/', '')}`
    : (isDataUrl(form?.file) ? form.file : null);

  const handleChangeImageForImage = async (img) => {
    if (!img) return;
    const base64 = await toBase64(img);
    if (!base64) return;
    handleChangeForm({ image: base64 });
  };

  const handleChangeImageForFile = async (img) => {
    if (!img) return;
    const base64 = await toBase64(img);
    if (!base64) return;
    handleChangeForm({ file: base64 });
  };

  const handleDeleteForImage = async () => {
    handleChangeForm({ image: null });
  };

  const handleDeleteForFile = async () => {
    handleChangeForm({ file: null });
  };

  const getData = useCallback(() => {
    setActivePage("offers");
    getProvidersListAction(dispatch);
    if (id) {
      getOfferAction(dispatch ,id);
    }
  }, [dispatch, setActivePage, id]);

  async function deleteOffer(id) {
    await deleteOfferAction(dispatch, id);
    history.push("/offers");
  }

  function handleChangeForm(obj) {
    const data = {...form, ...obj}
    // IMPORTANT: do not "format/round" while typing, otherwise the last cent digit
    // can be forced to 0 (e.g. 65.10) and the input becomes hard to edit.
    const nextPrice = parseLocaleNumber(data?.price);
    const nextPricePA = parseLocaleNumber(data?.pricePA);
    let value = nextPrice && nextPricePA ? 100 - (nextPrice * 100) / nextPricePA : 0;
    value = parseFloat(value).toFixed(2);
    if (value < 0) {
      value = 0;
    }
    if (adventage.type === 'discount') {
      setAdventage({
        ...adventage,
        value,
      })
    }
    
    // Gérer boxProducts lors du changement de packing
    if (obj.packing !== undefined) {
      if (obj.packing !== 'box') {
        data.box = '';
        data.boxProducts = [];
      } else if (!data.boxProducts) {
        data.boxProducts = [];
      }
    }
    
    setForm(data);
  }
  
  const handleAddBoxProduct = () => {
    const updatedData = { ...form };
    const boxProducts = updatedData.boxProducts || [];
    boxProducts.push({
      gencod: '',
      libelle: '',
      quantity: '',
      pricePA: '',
      deee: ''
    });
    handleChangeForm({ boxProducts });
  };

  const handleRemoveBoxProduct = (index) => {
    const updatedData = { ...form };
    const boxProducts = [...(updatedData.boxProducts || [])];
    boxProducts.splice(index, 1);
    handleChangeForm({ boxProducts });
  };

  const handleBoxProductChange = (index, field, value) => {
    const updatedData = { ...form };
    const boxProducts = [...(updatedData.boxProducts || [])];
    if (boxProducts[index]) {
      // Convertir les champs numériques en nombres
      let processedValue = value;
      if (['quantity', 'pricePA', 'deee'].includes(field)) {
        if (value === '' || value === null || value === undefined) {
          processedValue = '';
        } else {
          const numValue = Number.parseFloat(value);
          processedValue = Number.isNaN(numValue) ? value : numValue;
        }
      }
      
      boxProducts[index] = { ...boxProducts[index], [field]: processedValue };
      handleChangeForm({ boxProducts });
    }
  }; 

  function submit(obj = {}) {
    const data = {...form, ...obj };

    // Normalize numeric fields that can be entered with ",".
    const normalizedPrice = roundTo2(parseLocaleNumber(data.price));
    const normalizedPricePA = roundTo2(parseLocaleNumber(data.pricePA));
    if (normalizedPrice !== null) data.price = normalizedPrice;
    if (normalizedPricePA !== null) data.pricePA = normalizedPricePA;

    const errorsData = {}  
    if (!data.ref) {
      errorsData.ref = required;
    }
    if (data.ref?.length > 19) {
      errorsData.ref = "la référence a plus de 19 caractères";
    }
    // if (!data.brand) {
    //   errorsData.brand = required;
    // }
    if (data?.brand?.length > 30) {
      errorsData.brand = "la marque a plus de 30 caractères";
    }
    if (!data.gencod) {
      errorsData.gencod = required;
    }
    if (data?.gencod?.length !== 13) {
      errorsData.gencod = "le gencod n'a pas 13 caractères";
    }
    if (!data.description) {
      errorsData.description = required;
    }
    if (data.description.length > 100) {
      errorsData.description = "la description a plus de 100 caractères";
    }
    if (!data.packing) {
      errorsData.packing = required;
    }
    if (!data.company) {
      errorsData.company = required;
    }
    if (!data.price) {
      errorsData.price = required;
    }
    // En création: image + fiche obligatoires. En édition: ok si déjà présentes côté offer.
    if (!offer?._id && !data.image) {
      errorsData.image = "l'image est requise";
    }
    if (!offer?._id && !data.file) {
      errorsData.file = "la fiche produit est requise";
    }
    if (!data.product) {
      errorsData.product = required;
    }
    if (data.deee === '') {
      errorsData.deee = required;
    }
    if (!data.tax && data.tax !== 0) {
      errorsData.tax = required;
    }
    if (!data.brand) {
      errorsData.brand = required;
    }
    if (!data.availability) {
      errorsData.availability = required;
    }
    if (data?.availability === 'other' && !data.availabilityComment) {
      errorsData.availabilityComment = required;
    }
    // if (!adventage.value) {
    //   errorsData.adventages = required;
    // }
    setErrors(errorsData);
    if (Object.keys(errorsData).length > 0) {
      return null;
    }

    data.discount = null;
    data.punch = null;
    data.gift = null;

    if (adventage.type && adventage.value) {
      data[adventage.type] = adventage.value;
    }
    if (form?.company?._id) {
      data.company = form?.company?._id;
    }

    // Normalisation image/file:
    // - create: on envoie data URLs
    // - edit: on envoie seulement si null (suppression) ou data URL (remplacement)
    if (offer?._id) {
      if (!(data.image === null || isDataUrl(data.image))) delete data.image;
      if (!(data.file === null || isDataUrl(data.file))) delete data.file;
    } else {
      if (data.image && !isDataUrl(data.image)) delete data.image;
      if (data.file && !isDataUrl(data.file)) delete data.file;
    }
    if (data?.tva) {
      data.tva = parseFloat(data.tva);
    }

    if(!offer?._id) {
      return postProductAction(dispatch, {...data });
    }
    putProductAction(dispatch, offer?._id,  data );
    return store.addNotification({
      message: "L'offre a été modifiée",
      type: "success",
      insert: "top",
      container: "bottom-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true
      }
    });
  }

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    if (offer?._id) {
      if (offer.discount) {
        setAdventage({ type: "discount", value: parseFloat(offer.discount) });
      }
      if (offer.punch) {
        setAdventage({ type: "punch", value: offer.punch });
      }
      if (offer.gift) {
        setAdventage({ type: "gift", value: offer.gift });
      }
      
      // Convertir les boxProducts pour s'assurer que les valeurs numériques sont des nombres
      const boxProducts = (offer?.boxProducts || []).map(item => ({
        ...item,
        quantity: item.quantity ? Number(item.quantity) : '',
        pricePA: item.pricePA ? Number(item.pricePA) : '',
        deee: item.deee !== undefined && item.deee !== null && item.deee !== '' ? Number(item.deee) : ''
      }));
      
      setForm({
        ...offer,
        fileNumber: offer?.fileNumber ?? resolveFileNumber(offer?.product),
        boxProducts: boxProducts
      });
    }
  },[offer]);

  useEffect(() => {
    if (form.company) {
      getProviderAction(dispatch, form?.company?._id || form.company);
    }
  }, [dispatch, form, form.company])

  useEffect(() => {
    if (typeof message === 'string') {
      store.addNotification({
        message,
        type: "success",
        insert: "top",
        container: "bottom-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      dispatch({
        type : MESSAGE_OFFERS,
        payload : null,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[message]);

  useEffect(() => {
    if (error?.data?.message === 'This product is used in some Orders') {
      store.addNotification({
        message: "Ce produit est utilisé dans certaines commandes",
        type: "danger",
        insert: "top",
        container: "bottom-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 6000,
          onScreen: true
        }
      });
      dispatch({
        type : ERROR_OFFERS,
        payload : null,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[error?.data?.message]);

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.back}>
        {offer?._id ?
          <Link to={`/offer-view/${offer?._id }`}>
           <img src={getAssetPath(arrow)} alt="back"/> <p>Retour</p>
          </Link>
        :
          <Link to={`/offers`}>
           <img src={getAssetPath(arrow)} alt="back"/> <p>Retour</p>
          </Link>
        }
      </div>
      <header className={styles.header}>
        <h1>{offer?.ref || 'Nouveau produit' }</h1>
        <div className={styles.actions}>
          {offer?._id
              && <button
                className={styles.delete}
                onClick={() => deleteOffer(offer?._id)}
             >
                Supprimer le produit
              </button>
            }
          <button
            type="button"
            className={styles.submit}
            onClick={() => submit()}
          >
            Enregistrer
          </button>
        </div>
      </header>

      <main className={styles.content}>
        <div className={styles['col-2']}>
          <div className={styles.block}>
            <h2>Info</h2>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <StyledSelect
                  className="input secondary"
                  label="Status de l'offre"
                  value={offersStatusOptions?.find((d) => d.value === form?.status)}
                  options={offersStatusOptions}
                  placeholder="Sélectionner"
                  onChange={(opt) => handleChangeForm({ status: opt.value })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Référence du produit"
                  value={form?.ref || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.ref}
                  loading={false}
                  onChange={(val) => handleChangeForm({ ref : val?.toUpperCase() })}
                />
              </div>
              {productsOptions?.length > 0 &&
                <div className={styles['col-2']}>
                  <StyledSelect
                    className="input secondary"
                    label="Famille de produit"
                    value={productsOptions?.find((d) => d.value === form?.product)}
                    options={productsOptions}
                    error={errors?.product}
                    placeholder="Sélectionner"
                    onChange={(opt) => handleChangeForm({
                      product: opt?.value ?? null,
                      fileNumber: opt?.value ? resolveFileNumber(opt.value) : null,
                    })}
                  />
                </div>
              }
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <StyledSelect
                  className="input secondary"
                  label="Fournisseur"
                  value={providersOptions?.find((d) => d.value === form?.company?._id || d.value === form?.company)}
                  options={providersOptions}
                  error={errors?.company}
                  placeholder="Sélectionner"
                  onChange={(opt) => handleChangeForm({ company: opt.value })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Marque"
                  value={form?.brand || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.brand}
                  loading={false}
                  onChange={(val) => handleChangeForm({ brand : val?.toUpperCase() })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Gencod"
                  value={form?.gencod || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.gencod}
                  loading={false}
                  onChange={(val) => handleChangeForm({ gencod : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <label className="bold" style={{ marginBottom: 4, display: 'block' }}>
                  Visuel produit{!offer?._id ? <span className="text-error"> *</span> : null}
                </label>
                <InputImage
                  id="cover"
                  defaultValue={defaultImageValue}
                  disabled={false}
                  handleChangeImage={handleChangeImageForImage}
                  handleDelete={handleDeleteForImage}
                  placeholder={"Cliquez pour déposer le visuel produit au format .jpg ou .png"}
                  accept="image/png, image/jpeg"
                />
                <span className={`text-error ${styles.error}`}>{errors?.image ? errors.image : ""}</span>
              </div>
              <div className={styles['col-2']}>
                <label className="bold" style={{ marginBottom: 4, display: 'block' }}>
                  Fiche produit{!offer?._id ? <span className="text-error"> *</span> : null}
                </label>
                <InputImage
                  id="file"
                  defaultValue={defaultFileValue}
                  disabled={false}
                  handleChangeImage={handleChangeImageForFile}
                  handleDelete={handleDeleteForFile}
                  placeholder={"Cliquez pour déposer la fiche produit au format .jpg, .png ou .pdf"}
                  accept="image/png, image/jpeg, application/pdf"
                  allowPdf
                />
                <span className={`text-error ${styles.error}`}>{errors?.file ? errors.file : ""}</span>
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-1']}>
                <Textarea
                  label="Designation du produit"
                  value={form?.description || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.description}
                  loading={false}
                  onChange={(val) => handleChangeForm({ description : val})}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-1']}>
                <Input
                  label="Typo"
                  value={form?.type || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.type}
                  loading={false}
                  onChange={(val) => handleChangeForm({ type : val})}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Code article"
                  value={form?.code || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.code}
                  loading={false}
                  onChange={(val) => handleChangeForm({ code : val })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Numéro de dossier"
                  value={form?.fileNumber || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.fileNumber}
                  loading={false}
                  onChange={(val) => handleChangeForm({ fileNumber : val })}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles['col-2']}>
          <div className={styles.block}>
            <h2>Colisage</h2>
            <div className={styles.row}>
              <div className={styles.toggles}>
                <button
                  type="button"
                  onClick={() => handleChangeForm({ packing: '' })}
                  className={form?.packing !== 'box' ? styles.active : ''}
                >
                  Colis
                </button>
                <button
                  type="button"
                  onClick={() => handleChangeForm({ packing: "box"})}
                  className={form?.packing === 'box' ? styles.active : ''}
                >
                  Box
                </button>
              </div>
            </div>
            <div className={styles.row}>
              {form.packing === 'box' &&
                <div className={styles['col-1']}>
                  <label className="bold">Détails box*</label>
                  <div className={styles.boxProductsTable}>
                    <table>
                      <thead>
                        <tr>
                          <th>Gencod*</th>
                          <th>Libellé*</th>
                          <th>Quantité*</th>
                          <th>PA unitaire HT*</th>
                          <th>DEEE/Ecomobilier HT*</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {(form.boxProducts || []).map((item, index) => (
                          <tr key={index}>
                            <td>
                              <NumberFormat
                                format="#############"
                                placeholder='_____________'
                                mask='_'
                                value={item.gencod || ''}
                                onChange={(e) => {
                                  handleBoxProductChange(index, 'gencod', e.target.value.trim());
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={item.libelle || ''}
                                onChange={(e) => {
                                  handleBoxProductChange(index, 'libelle', e.target.value);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                min="1"
                                step="1"
                                value={item.quantity || ''}
                                onChange={(e) => {
                                  handleBoxProductChange(index, 'quantity', e.target.value);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={item.pricePA || ''}
                                onChange={(e) => {
                                  handleBoxProductChange(index, 'pricePA', e.target.value);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={item.deee || ''}
                                onChange={(e) => {
                                  handleBoxProductChange(index, 'deee', e.target.value);
                                }}
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className={styles.removeButton}
                                onClick={() => handleRemoveBoxProduct(index)}
                              >
                                ×
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button
                      type="button"
                      className={styles.addButton}
                      onClick={handleAddBoxProduct}
                    >
                      + Ajouter un article
                    </button>
                  </div>
                  <Textarea
                    label="Informations complémentaires"
                    value={form?.box || ''}
                    placeholder={""}
                    type={"text"}
                    className="input secondary"
                    loading={false}
                    onChange={(val) => handleChangeForm({ box : val})}
                  />
                </div>
              }
              {form.packing !== 'box' &&
                <div className={styles['col-2']}>
                  <Input
                    label="Nbre d'UVC par colis"
                    value={form?.packing || ''}
                    placeholder={""}
                    type={"text"}
                    error={errors?.packing}
                    className="input secondary"
                    loading={false}
                    onChange={(val) => handleChangeForm({ packing : val})}
                  />
                </div>
              }
            </div>
          </div>
          <div className={styles.block}>
            <h2>Tarif</h2>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Prix net salon"
                  value={form?.price}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  loading={false}
                  step="0.01"
                  error={errors?.price}
                  onChange={(val) => handleChangeForm({ price: val })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="PA permanent (si permanent)"
                  value={form?.pricePA}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.pricePA}
                  loading={false}
                  onChange={(val) => handleChangeForm({ pricePA : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="PA BRUT"
                  value={form?.pricePABrut}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.pricePABrut}
                  loading={false}
                  onChange={(val) => handleChangeForm({ pricePABrut : val  })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="TVA"
                  value={form?.tva}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.tva}
                  loading={false}
                  onChange={(val) => handleChangeForm({ tva : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="DEEE"
                  value={form?.deee}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  loading={false}
                  step="0.01"
                  error={errors?.deee}
                  onChange={(val) => handleChangeForm({ deee: val })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Autres taxes"
                  value={form?.tax}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.tax}
                  loading={false}
                  onChange={(val) => handleChangeForm({ tax : val })}
                />
              </div>
            </div>
            <div className={styles.adventages}>
              <label className='bold'>Avantage salon</label>
              <div className={styles.list}>
                <div className={styles.item}
                  onClick={() => setAdventage(adventage.type !== "gift" ? { type: "gift" , value: "" } : { type: null , value: null })}
                > 
                  <div className={`${styles.icon} ${adventage.type === "gift" &&  styles.active}`}> 
                    <img src={getAssetPath(gift)} alt="gift" />
                  </div>
                  <p>Cadeau</p>
                </div>
                <div className={styles.item}
                  onClick={() => setAdventage(adventage.type !== "punch" ? { type: "punch" , value: "" } : { type: null , value: null })}
                > 
                  <div className={`${styles.icon} ${adventage.type === "punch" && styles.active}`}> 
                    <img src={getAssetPath(fist)} alt="gift" />
                  </div>
                  <p>Coup de poing</p>
                </div>
                <div className={styles.item}
                  onClick={() => setAdventage(adventage.type !== "discount" ? { type: "discount" , value: discount } : { type: null , value: null })}
                > 
                  <div className={`${styles.icon} ${adventage.type === "discount"  && styles.active}`}> 
                    <img src={getAssetPath(promo)} alt="gift" />
                  </div>
                  <p>% remise</p>
                </div>
              </div>
              {errors.adventages && <p className={styles.error}>{errors.adventages}</p>}
            </div>
              <div className={styles.row}>
                {adventage.type === "gift" &&
                  <div className={styles['col-2']}>
                    <Input
                      label="Cadeau"
                      value={adventage.value}
                      placeholder={""}
                      type={"text"}
                      className="input secondary"
                      loading={false}
                      onChange={(val) => setAdventage({ type: "gift", value: val })}
                    />
                  </div>
                }
                {adventage.type === "punch" &&
                  <div className={styles['col-2']}>
                    <Input
                      label="Coup de poing"
                      value={adventage.value}
                      placeholder={""}
                      type={"text"}
                      className="input secondary"
                      loading={false}
                      onChange={(val) => setAdventage({ type: "punch", value: val })}
                    />
                  </div>
                }
                {adventage.type === "discount" &&
                  <div className={styles['col-2']}>
                    <Input
                      label="Promotion"
                      value={adventage.value ? parseFloat(adventage.value) : ''}
                      placeholder={""}
                      type={"number"}
                      className="input secondary"
                      loading={false}
                      step="0.01"
                      onChange={(val) => setAdventage({ type: "discount", value: val > 0 ? parseFloat(val): val })}
                    />
                  </div>
                }
              </div>
          </div>
          <div className={styles.block}>
            <h2>Disponibilité</h2>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <StyledSelect
                  className="input secondary"
                  label="Disponibilité produit"
                  value={availabilityOptions?.find((d) => d.value === form?.availability)}
                  options={availabilityOptions}
                  placeholder="Sélectionner"
                  onChange={(opt) => handleChangeForm({ availability: opt.value })}
                />
              </div>
            </div>
            {form?.availability === "other" &&
              <div className={styles.row}>
                <div className={styles['col-1']}>
                  <Input
                    label="Délai de livraison"
                    value={form?.availabilityComment || ''}
                    placeholder={""}
                    type={"text"}
                    className="input secondary"
                    error={errors?.availabilityComment}
                    loading={false}
                    onChange={(val) => handleChangeForm({ availabilityComment : val})}
                  />
                </div>
              </div>
            }
          </div>
        </div>
      </main>

    </div>
  )
}
